/* bd-v156 (2026-09-08): retour- en douaneregel onder de koopknop.
   Uit de conversie-audit: het koopblok toont Delivery, Toolkit en Access,
   maar nergens de retourvoorwaarde , terwijl dat juist het bezwaar is dat
   een koude bezoeker van EUR 99-169 tegenhoudt.
   Alle teksten komen letterlijk uit je eigen beleidspagina's:
     retour   : "return of a physical product within 30 days after receiving
                 it. This applies to the Physical Deck and to the physical
                 component of the Complete Package."
     douane   : "outside the European Union, destination authorities or
                 carriers may charge import duties, import VAT,
                 customs-clearance fees, or handling charges"
   Er wordt niets beloofd wat je beleid niet zegt. */
(function () {
  'use strict';

  // Instellingen uit de theme-editor; zonder instellingen dezelfde teksten.
  var CFG = (window.BD_V149 && window.BD_V149.trust) || {};
  function woord(v, terugval) {
    return (typeof v === 'string' && v.length) ? v : terugval;
  }
  function veilig(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  var T_FYSIEK = woord(CFG.physical, '30 days to return the printed deck after delivery.');
  var T_DIGITAAL = woord(CFG.digital, 'Digital access starts right after checkout.');
  var T_DOUANE = woord(CFG.customs,
    'Delivery outside the EU: import duties, VAT or handling fees may be charged on arrival.');
  var DOUANE_AAN = CFG.customsOn !== false;
  var URL_RETOUR = woord(CFG.returnsUrl, '/policies/refund-policy');
  var LBL_RETOUR = woord(CFG.returnsLabel, 'Returns policy');
  var URL_VERZEND = woord(CFG.shippingUrl, '/pages/shipping-pre-order-info');
  var LBL_VERZEND = woord(CFG.shippingLabel, 'Shipping info');

  var EU = ('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT ' +
            'RO SK SI ES SE').split(' ');

  var CSS = [
    '.bd-trust{order:5;display:grid;gap:7px;margin:10px 0 0}',
    '.bd-trust__row{display:flex;align-items:flex-start;gap:9px;font-size:13px;line-height:1.4;',
    'color:rgba(var(--color-foreground,11 18 32),.72)}',
    '.bd-trust__row svg{flex:0 0 auto;width:17px;height:17px;margin-top:1px;',
    'color:rgb(var(--color-button,31 86 229))}',
    '.bd-trust__row a{color:inherit;text-decoration:underline;text-underline-offset:2px}',
    '.bd-trust__row--warn{color:rgba(var(--color-foreground,11 18 32),.82)}',
    '.bd-trust__row--warn svg{color:#b8860b}',
    '.bd-trust__row--green,.bd-trust__row--green svg{color:#15803D;font-weight:700}'
  ].join('');

  var ICON_RETOUR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>';
  var ICON_DOUANE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M12 9v4M12 17h.01"/><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg>';

  // RETURNS-03 (22 Oct 2026, owner): a reassuring shield with a tick for the 30-day return line
  var ICON_SCHILD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>';
  function q(s, r) { return (r || document).querySelector(s); }

  function land() {
    try { return (window.Shopify && window.Shopify.country) || ''; } catch (e) { return ''; }
  }
  function buitenEU() {
    var c = land();
    return !!c && EU.indexOf(c) === -1;
  }

  function stijl() {
    if (document.getElementById('bd-trust-css')) return;
    var s = document.createElement('style');
    s.id = 'bd-trust-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function regel(icoon, html, warn, groen) {
    return '<div class="bd-trust__row' + (warn ? ' bd-trust__row--warn' : '') + (groen ? ' bd-trust__row--green' : '') + '">' +
           icoon + '<span>' + html + '</span></div>';
  }

  function teken() {
    // Vanaf de knop omhoog zoeken: er kan meer dan een paneel in de DOM staan.
    var btn = q('[data-bdp-main-add]');
    var acties = btn && btn.closest ? btn.closest('.bdp-selected__actions') : null;
    if (!acties) acties = q('.bdp-selected__actions');
    if (!acties || !acties.parentNode) return;
    // Onder het groene verzendblok, boven Quantity.
    var anker = acties.parentNode.querySelector('.bdp-selected__fulfilment') || acties;

    var titel = (q('.bdp-selected__title') || {}).textContent || '';
    titel = titel.replace(/\s+/g, ' ').trim().toLowerCase();
    // Alleen deze twee bevatten een gedrukt deck; de rest is puur digitaal.
    // RETURNS-03: by the chosen product (the title is translated on /de/ and /fr/), title only as a fallback
    var kaart = q('[data-bdp-card][aria-pressed="true"]');
    var hnd = kaart ? (kaart.getAttribute('data-product-handle') || '') : '';
    var fysiek = hnd ? /^(mba-tools|complete-package)$/.test(hnd) : /complete|physical/.test(titel);

    function link(url, label) {
      return ' <a href="' + veilig(url) + '">' + veilig(label) + '</a>';
    }

    var douane = fysiek && DOUANE_AAN && buitenEU();
    var html = '';
    if (fysiek) {
      // RETURNS-02 (22 Oct 2026, owner): no policy link, the line in green
      // RETURNS-04 (22 Oct 2026, owner): the 30-day line now sits with the green lines above Add to cart
      // (bd-workbook-bonus.js), so it is not repeated here
      if (douane) {
        html += regel(ICON_DOUANE, veilig(T_DOUANE) + link(URL_VERZEND, LBL_VERZEND), true);
      }
    }
    // DIGITAL-02 (22 Oct 2026, owner): the digital line ("Digital access starts right after checkout.") is gone

    var blok = q('.bd-trust', acties.parentNode);
    if (!html) { if (blok) blok.remove(); return; }
    if (!blok) {
      blok = document.createElement('div');
      blok.className = 'bd-trust';
      anker.parentNode.insertBefore(blok, anker.nextSibling);
    }

    // NIET vergelijken met blok.innerHTML: de browser serialiseert SVG anders
    // terug (<path .../> wordt <path ...></path>), dus die vergelijking is
    // altijd ongelijk. Dan schrijft elke observer-tik opnieuw, wat weer een
    // mutatie is, en dat loopt oneindig door. Daarom een eigen statussleutel.
    var sleutel = (fysiek ? 'f' : 'd') + (douane ? '+eu' : '');
    if (blok.getAttribute('data-bd-trust') === sleutel) return;
    blok.setAttribute('data-bd-trust', sleutel);

    // Observer even losklikken tijdens het schrijven, als extra vangnet.
    if (kijker) kijker.disconnect();
    blok.innerHTML = html;
    if (kijker) verbind();
  }

  var kijker = null;
  function verbind() {
    var doel = q('.bdp-panel') || q('.bdp-selected__content');
    if (doel && kijker) kijker.observe(doel, { childList: true, subtree: true, characterData: true });
  }

  function start() {
    if (!q('.bdp-selected__actions')) return;
    stijl();
    teken();
    document.addEventListener('bd:selection-change', teken);
    try {
      kijker = new MutationObserver(function () { teken(); });
      verbind();
    } catch (e) { kijker = null; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
